import React, { FC } from 'react';

const IconRegalo: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 18" {...props}>
      <path
        fillRule="evenodd"
        d="M19,12 L19,21 L5,21 L5,12 L19,12 Z M20,8 L20,11 L4,11 L4,8 L20,8 Z M9.66416384,3 C11.1657524,3 10.9940518,7 10.9940518,7 L10.9940518,7 L8.99702588,7 C7.89409894,7 7,6.1045695 7,5 C7,3.8954305 8.16257525,3 9.66416384,3 Z M14.3358362,3 C15.8374248,3 17,3.8954305 17,5 C17,6.1045695 16.1059011,7 15.0029741,7 L13.0059482,7 L13.0059482,7 C13.0059482,7 12.8342476,3 14.3358362,3 Z"
        transform="translate(-4 -3)"
      />
    </svg>
  );
};

export default IconRegalo;
